export default {
  data() {
    this.i18n.mergeLocaleMessage("fr", {
      regions: {
        label: "Région",
        1: "Abitibi-Témiscamingue",
        2: "Bas-Saint-Laurent",
        3: "Centre-du-Québec",
        4: "Chaudière-Appalaches",
        5: "Côte-Nord",
        6: "Estrie",
        7: "Gaspésie - Îles-de-la-Madeleine",
        8: "Lanaudière",
        9: "Laurentides",
        10: "Laval",
        11: "Mauricie",
        12: "Montérégie",
        13: "Montréal",
        14: "Nord-du-Québec",
        15: "Nunavik",
        16: "Outaouais",
        17: "Québec",
        18: "Saguenay - Lac-Saint-Jean",
        19: "Terres-cries-de-la-Baie-James",
      },
      establishment_type: {
        label: "Type d'établissement",
        1: "Centre jeunesse",
        2: "Maison des jeunes",
        3: "École primaire",
        4: "École secondaire",
        5: "Cégep",
        6: "Université",
        7: "Entreprise privée",
        8: "Ministère",
        9: "CISSS ou CIUSSS",
        10: "Établissement de santé",
        11: "Bibliothèque",
        12: "Municipalité",
        13: "Pharmacie",
        14: "Bureau de dentiste",
        15: "Clinique médicale",
        16: "Autre",
      },
      language: {
        label: "Langue parlée",
        1: "Français",
        2: "Anglais",
      },
      title: {
        label: "Titre",
        1: "M",
        2: "Mme",
      },
      countries: {
        label: "Pays",
        1: "CA",
      },
      provinces: {
        label: "Province",
        1: "QC",
      },
      gender: {
        label: "Genre du patient",
        1: "Homme",
        2: "Femme",
        3: "Autre",
        4: "Préfère ne pas répondre",
      },
      rules: {
        required: "Ce champ est requis",
        email: "Le format de courriel n'est pas valide",
        postal: "Le format du code postal n'est pas valide (H1H 1H1)",
        sameAsEmail: "Le courriel doit être identique",
      },
    });

    this.i18n.mergeLocaleMessage("en", {
      language: {
        label: "Language",
        1: "French",
        2: "English",
      },
      title: {
        label: "Title",
        1: "Mr",
        2: "Ms",
      },
      countries: {
        label: "Country",
        1: "CA",
      },
      provinces: {
        label: "Province",
        1: "QC",
      },
      gender: {
        label: "Patient's gender",
        1: "Man",
        2: "Woman",
        3: "Other",
        4: "Prefer not to answer",
      },
      rules: {
        required: "This field is required",
        email: "The email isn't in the proper format",
        postal: "The postal code isn't in the proper format (H1H 1H1)",
        sameAsEmail: "The email needs to be identical",
      },
    });
    return {
      is_submitting: false,
      title_options: [
        {
          text: this.t("title.1"),
          value: "mTitle",
        },
        {
          text: this.t("title.2"),
          value: "mmeTitle",
        },
      ],
      establishment_type_options: [
        {
          text: this.t("establishment_type.1"),
          value: "youthCenter",
        },
        {
          text: this.t("establishment_type.2"),
          value: "youthClub",
        },
        {
          text: this.t("establishment_type.3"),
          value: "primarySchool",
        },
        {
          text: this.t("establishment_type.4"),
          value: "highSchool",
        },
        {
          text: this.t("establishment_type.5"),
          value: "cegep",
        },
        {
          text: this.t("establishment_type.6"),
          value: "university",
        },
        {
          text: this.t("establishment_type.7"),
          value: "privateEntreprise",
        },
        {
          text: this.t("establishment_type.8"),
          value: "ministry",
        },
        {
          text: this.t("establishment_type.9"),
          value: "cisssCiusss",
        },
        {
          text: this.t("establishment_type.10"),
          value: "healthEstablishment",
        },
        {
          text: this.t("establishment_type.11"),
          value: "library",
        },
        {
          text: this.t("establishment_type.12"),
          value: "municipality",
        },
        {
          text: this.t("establishment_type.13"),
          value: "pharmacy",
        },
        {
          text: this.t("establishment_type.14"),
          value: "dentistOffice",
        },
        {
          text: this.t("establishment_type.15"),
          value: "medicalClinic",
        },
        {
          text: this.t("establishment_type.16"),
          value: "other",
        },
      ],
      language_options: [
        {
          text: this.t("language.1"),
          value: "french",
        },
        {
          text: this.t("language.2"),
          value: "english",
        },
      ],
      regions: [
        {
          text: this.t("regions.1"),
          value: "abitibiTemiscamingue",
        },
        {
          text: this.t("regions.2"),
          value: "basSaintLaurent",
        },
        {
          text: this.t("regions.3"),
          value: "centreDuQuebec",
        },
        {
          text: this.t("regions.4"),
          value: "chaudiereAppalaches",
        },
        {
          text: this.t("regions.5"),
          value: "coteNord",
        },
        {
          text: this.t("regions.6"),
          value: "estrie",
        },
        {
          text: this.t("regions.7"),
          value: "gaspesieIlesDeLaMadeleine",
        },
        {
          text: this.t("regions.8"),
          value: "lanaudiere",
        },
        {
          text: this.t("regions.9"),
          value: "laurentides",
        },
        {
          text: this.t("regions.10"),
          value: "laval",
        },
        {
          text: this.t("regions.11"),
          value: "mauricie",
        },
        {
          text: this.t("regions.12"),
          value: "monteregie",
        },
        {
          text: this.t("regions.13"),
          value: "montreal",
        },
        {
          text: this.t("regions.14"),
          value: "nordDuQuebec",
        },
        {
          text: this.t("regions.15"),
          value: "nunavik",
        },
        {
          text: this.t("regions.16"),
          value: "outaouais",
        },
        {
          text: this.t("regions.17"),
          value: "quebec",
        },
        {
          text: this.t("regions.18"),
          value: "saguenayLacSaintJean",
        },
        {
          text: this.t("regions.19"),
          value: "terresCriesDeLaBaieJamies",
        },
      ],
      provinces: [
        {
          text: this.t("provinces.1"),
          value: "qc",
        },
      ],
      countries: [
        {
          text: this.t("countries.1"),
          value: "ca",
        },
      ],
      gender_options: [
        {
          text: this.t("gender.1"),
          value: "male",
        },
        {
          text: this.t("gender.2"),
          value: "female",
        },
        {
          text: this.t("gender.3"),
          value: "others",
        },
        {
          text: this.t("gender.4"),
          value: "noAnswer",
        },
      ],
      recaptcha_index: 0,
      recaptcha_error: false,
    };
  },
  methods: {
    async submit() {
      if (this.is_submitting) return;

      this.recaptcha_error = false;

      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        this.$nextTick(() => {
          const result = document.querySelector(".error");
          if (result) {
            return window.scrollTo({
              top: result.parentNode.offsetTop - 86,
              behavior: "smooth",
            });
          }
        });
        return;
      }

      if (window.grecaptcha.getResponse(this.recaptcha_index).length === 0) {
        this.recaptcha_error = true;
        return;
      }

      this.is_submitting = true;

      try {
        await this.$apollo.mutate({
          mutation: this.query,
          variables: this.payload,
        });
        if (this.nuxtApp) {
          this.nuxtApp.$event("success");
        }
      } catch (e) {
        console.log(e);
        if (this.nuxtApp) {
          this.nuxtApp.$event("error", e);
        }
      }
      this.is_submitting = false;
    },
  },
};
